import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Avatar } from 'primeng/avatar';

import { AuthService } from '@auth/services/auth.service';

import { EditProfileModalService } from '../edit-profile-modal/edit-profile-modal.service';
import { ButtonSize, ButtonType, YButton } from '../y-button/y-button';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'yt-profile-overlay',
  templateUrl: './profile-overlay.html',
  styleUrls: ['./profile-overlay.scss'],
  imports: [YButton, Avatar],
  standalone: true
})
export class ProfileOverlay {
  private readonly authService = inject(AuthService);
  readonly editProfileModalService = inject(EditProfileModalService);

  readonly authUser = this.authService.authUser;

  readonly document = document;
  readonly ButtonSize = ButtonSize;
  readonly ButtonType = ButtonType;

  logout() {
    void this.authService.logout();
  }
}
